const loadCloserScript = () => {
    var conf = {
        closerScriptBaseUrl: 'https://widget.opl.closer.app',
        closerOrgId: 'fe4ef385-48ab-4749-acbc-5c31ad7134e1',
        enableCloserLog: false
    };

    if (window.WC.config.env.CloserOrgId && window.WC.config.env.CloserWidgetBaseURL) {
        conf = {
            closerScriptBaseUrl: window.WC.config.env.CloserWidgetBaseURL,
            closerOrgId: window.WC.config.env.CloserOrgId,
            enableCloserLog: window.WC.config.env.enableCloserLog
        };
    }

    if (window._closerDevConfig && window._closerDevConfig.defaultCloserEnvs) {
        conf = {
            closerScriptBaseUrl: window._closerDevConfig.defaultCloserEnvs.closerScriptBaseUrl,
            closerOrgId: window._closerDevConfig.defaultCloserEnvs.closerOrgId,
            enableCloserLog: window._closerDevConfig.defaultCloserEnvs.enableCloserLog
        };
    }

    (function (c, l, o, s, e, r) {
        c.closer = c.closer || { q: [] };
        ['init', 'reinit', 'identify', 'openWidget', 'deinit'].forEach(function (m) {
            c.closer[m] = function () {
                this.q.push({ method: m, args: arguments });
            };
        });
        c.closer['scriptUrl'] = s;
        e = l.createElement(o);
        e.async = 1;
        e.src = s;
        r = l.getElementsByTagName(o)[0];
        r.parentNode.insertBefore(e, r);
    })(window, document, 'script', `${conf.closerScriptBaseUrl}/widget.js`);

    return [conf.closerOrgId, conf.closerScriptBaseUrl, conf.enableCloserLog];
};

export { loadCloserScript };
